export const MinorPreviewRoutesSegments = {
  RelationshipConfirmation: 'relationship-confirmation',
  MinorInformation: 'minor-information',
} as const;
